import React from 'react'
import * as UI from 'ui'
import {WhenModel} from '@morningtrain/react-resources'
import WhenOrderIsDeliveryNote from './WhenOrderIsDeliveryNote'
import DraftOrderItems from './DraftOrderItems'
import DeliveryNoteOrderItems from './DeliveryNoteOrderItems'
import {useEnvValue, WhenEnvValueMatches} from '@morningtrain/react-helpers'
import WhenOrderIsDraft from './WhenOrderIsDraft'
import WhenOrderIsPending from 'pages/app/inventory/order/partials/WhenOrderIsPending'
import PendingOrderItems from 'pages/app/inventory/order/partials/PendingOrderItems'
import {Translation, useTranslation} from "@morningtrain/react-translations";
import {Input} from "support/fields";

export default function OrderItems() {

    const [filterByString, setFilterByString] = useEnvValue('globals.inventory.filter_order_by_string', '')

    let searchPlaceHolder = useTranslation('inventory.order.titles.look_for')
    let onSearchChange = function (searchText) {
        setFilterByString(searchText)
    }

    return (
        <WhenEnvValueMatches name='globals.inventory.order_items'>
            <WhenOrderIsDraft>
                <UI.Card>
                    <Input
                        onChange={onSearchChange}
                        label={<Translation name={'inventory.order.titles.search'}/>}
                        placeholder={searchPlaceHolder}
                    />
                </UI.Card>
                <DraftOrderItems/>
            </WhenOrderIsDraft>
            <WhenModel>
                <WhenOrderIsPending>
                    <PendingOrderItems/>
                </WhenOrderIsPending>
                <WhenOrderIsDeliveryNote>
                    <DeliveryNoteOrderItems/>
                </WhenOrderIsDeliveryNote>
            </WhenModel>
        </WhenEnvValueMatches>
    )
}
